import React, { useState } from "react";
import classes from "./FaqMobile.module.css";
import { Container, Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import { Button } from "../../../../../stories/Button/Button";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import {
  cancelIcon,
  addicongray,
  AddIconGray,
  AddIconBlue,
} from "../../../../../constant/imagePath";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { CommonQuestions } from "../../../../../stories/CommonQuestions/CommonQuestions";
import { useHistory } from "react-router-dom";
import { Tabs } from "../../../../../stories/Tabs/Tabs";
import { TextArea } from "../../../../../stories/TextArea/TextArea";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../../../store/Actions/commonAction";
import { SignalCellularNullOutlined } from "@mui/icons-material";
import { setPersonalData } from "../../../../../store/Actions/authAction";

const FaqMobile = () => {
  const getDataFromRedux = useSelector((state) => state.onBoardingReducer?.faq);
  const dispatch = useDispatch();

  const history = useHistory();
  const [question, setQuestion] = useState(null);
  const [answer, setAnswer] = useState("");
  const [editingId, setEdititngId] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const activeTab = useSelector((state) => state?.commonReducer?.activeTab);

  const [faq, setFaq] = useState(getDataFromRedux ? getDataFromRedux : []);

  const handleDelete = (item) => {
    const newFaqData = faq?.slice();
    const index = newFaqData.findIndex((data) => data?._id === item?._id);
    newFaqData?.splice(index, 1);
    setFaq(newFaqData);
  };
  const handleEdit = (item) => {
    setEdititngId(item?._id);
    setIsEditing(true);
    faq.find((data) => {
      if (data?._id === item?._id) {
        setQuestion({ value: data?.question, label: data?.question });
        setAnswer(data?.answer);
      }
    });
  };

  const handleAddMore = () => {
    if (isEditing) {
      const newFaqData = faq?.slice();
      const index = newFaqData.findIndex((data) => data?._id === editingId);
      newFaqData?.splice(index, 1, {
        question: question?.label,
        answer: answer,
        _id: newFaqData[index]?.id,
      });
      setFaq(newFaqData);
      setIsEditing(false);
    } else {
      if (answer.length > 0 && question?.label?.length > 0) {
        setFaq([
          ...faq,
          {
            question: question?.label,
            answer: answer,
            _id: Math.floor(Math.random() * 1000),
          },
        ]);
      }
    }
    setQuestion(null);
    setAnswer("");
  };

  const convertedActiveTab = activeTab?.includes("-")
    ? activeTab.split("-")[0] + " " + activeTab.split("-")[1]
    : activeTab;

  function saveDataIntoRedux() {
    dispatch(setPersonalData("faq", faq));
  }

  return (
    <div className={[classes.FaqScreen].join(" ")}>
      <div className={[classes.mainheading, classes.mb32].join(" ")}>
        <img
          src={cancelIcon}
          className={[classes.crossimg]}
          alt="..."
          onClick={() => history.goBack()}
        />
        <p
          style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}
          className={[classes.textcenter].join(" ")}
        >
          Edit Profile
        </p>
      </div>

      <Container className={["p-0", classes.container].join(" ")}>
        <Row className={["g-0", classes.row].join(" ")}>
          <Col sm={12}>
            <Col sm={12} className={[classes.mb32].join(" ")}>
              <Tabs
                tabsData={[
                  { label: "Personal info", activeText: "personal-info" },
                  { label: "Photo & video", activeText: "photo-and-video" },
                  { label: "FAQ", activeText: "faq" },
                ]}
                state={{ label: convertedActiveTab }}
                setState={(item) => dispatch(setActiveTab(item?.activeText))}
              />
            </Col>

            {faq?.length > 0 && (
              <Col md={12} className={[classes.mb24].join(" ")}>
                <CommonQuestions
                  data={faq?.map((item) => ({
                    _id: item?._id,
                    title: item?.question,
                    description: item?.answer,
                  }))}
                  btnsPosition="Top"
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  headingStyle={{ ...Fonts.p1, fontFamily: "inter-600" }}
                />
              </Col>
            )}

            <Col md={12} className={[classes.mb32].join(" ")}>
              <DropDown
                options={[
                  {
                    label: "Are there any other fees?",
                    value: "Are there any other fees? ",
                  },
                ]}
                state={question}
                setter={setQuestion}
                label="Question"
                placeholder="Select Question"
              />
            </Col>

            <Col md={12} className={[classes.mb32].join(" ")}>
              <TextArea
                label="Answer"
                state={answer}
                setter={setAnswer}
                placeholder=""
              />
            </Col>

            <Col md={12} className={`${classes.mb76}`}>
              <LinkButtonWithIcon
                customStyle={{
                  ...Fonts.b2,
                  fontSize: "14px",
                  lineHeight: "20px",
                }}
                primary={true}
                text="Add more"
                onClick={handleAddMore}
                leftIcon={AddIconBlue}
                disabled={((answer == "" || question == null) && true) || false}
              />
            </Col>
          </Col>

          <Col xs={12} style={{ alignSelf: "flex-end" }}>
            <Button
              customStyle={{ width: "100%", height: "56px" }}
              primary={true}
              size="Large"
              onClick={saveDataIntoRedux}
            >
              Save changes
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default FaqMobile;
